import {inject, Injectable} from '@angular/core';
import {HttpParams} from '@angular/common/http';
import {Observable} from 'rxjs';
import {BaseApiService} from './base-api.service';

export interface UserNotification {
  id: number;
  entity: string | null;
  entity_id: number | null;
  source: string | null;
  title?: string | null;
  description?: string | null;
  note: string;
  payload: Record<string, unknown> | null;
  read_at: string | null;
  created_at: string;
}

interface NotificationApiResponse<T> {
  data: T;
  success: boolean;
}

export interface NotificationInbox {
  notifications: UserNotification[];
  unread_count: number;
  pagination: NotificationPagination;
}

export interface NotificationPagination {
  current_page: number;
  last_page: number;
  per_page: number;
  total: number;
  has_more: boolean;
}

export interface NotificationListParams {
  page?: number;
  perPage?: number;
  prioritizeUnread?: boolean;
}

@Injectable({providedIn: 'root'})
export class NotificationService extends BaseApiService {
  list({page = 1, perPage = 20, prioritizeUnread = false}: NotificationListParams = {}): Observable<NotificationApiResponse<NotificationInbox>> {
    let params = new HttpParams()
      .set('page', page)
      .set('per_page', perPage);

    if (prioritizeUnread) {
      params = params.set('prioritize_unread', '1');
    }

    return this.http.get<NotificationApiResponse<NotificationInbox>>(`${this.baseUrl}notifications`, {params});
  }

  markRead(notificationId: number): Observable<NotificationApiResponse<{ notification: UserNotification }>> {
    return this.http.patch<NotificationApiResponse<{ notification: UserNotification }>>(
      `${this.baseUrl}notifications/${notificationId}/read`,
      {},
    );
  }
}
